import {Component, inject, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import {take} from "rxjs/operators";
import {IUser} from '@signature-it/ngx-generic/interfaces';
import {SignedUserDTO} from '@signature-it/ngx-generic/models';
import {AuthService, FeaturesService, AccessibilityService, RouteService} from '@signature-it/ngx-generic/services';
import { InteractivityChecker } from "@angular/cdk/a11y";
import { GenericConfig } from '@signature-it/ngx-generic/config';
@Component({
    selector: 'cms-link-custom',
    templateUrl: './cms-link.html',
    styleUrls: ['./cms-link.scss'],
    standalone: false
})
export class CmsLinkComponentGeneric implements OnInit{
    @Input() dataHref;
    @Input() dataText;
    @Input() dataClasses;
    @Input() dataAriaLabel = "";
    @Input() dataId;
    @Input() dataIsLoginLink;
    @Input() dataDependApi;
    @Input() dataMoreinfo;
    @Input() sectionAnchor;
    @Input() dataRelativePath:boolean = false;
    @Input() target: '_self';
    @Input() baseLinkApp:boolean = false;
    href: string;
    text: string;
    classes: string;
    //isShow: boolean = true;
    _isShow: any;
    query_params: object;
    fragment: string;
    routeService: RouteService;
    router: Router;
    route: ActivatedRoute;
    isExternal: boolean = false;
    private _copyQueryParams: boolean = false;
    get isShow():any {
        return this._isShow;
    }
    @Input() set isShow(value:any) {
        this._isShow = value === 'false' ? false : true;
    }
    @Input() set copyQueryParams(value:any) {
        this._copyQueryParams = value === 'true' ? true : false;
    }
    get copyQueryParams() :boolean {
        return this._copyQueryParams;
    }
    constructor(protected authService: AuthService,
                protected featuresSvc: FeaturesService,
                protected a11ySvc: AccessibilityService,
                protected interactivityChecker: InteractivityChecker) {
        this.router = inject(Router);
        this.routeService = inject(RouteService);
        this.route = inject(ActivatedRoute);
    }

    ngOnInit() {
        if(this.baseLinkApp) {
            this.dataHref = `${GenericConfig.appURL}${this.dataHref}`;
        }
        this.isExternal = /^https?:\/\//i.test(this.dataHref);
        if (!this.isExternal) {
            this.setBaseLink();
            this.setFragment();
            this.setQueryParams();
        } else {
            this.href = this.dataHref;
        }
        if(this.dataDependApi) this.setIsShow();
        if(this.dataIsLoginLink) this.setLoginLink();
    }

    setIsShow() {
        this.isShow = false;
        this.featuresSvc.getResponseByApiUrl(this.dataDependApi)
            .subscribe(
                res => {
                    if (res) {
                        this.isShow = true;
                    }
                },
                err => {  },
            );
    }

    setLoginLink() {
        const self = this;
        this.authService.usersData$.pipe(take(2)).subscribe(function(user: IUser) {
            if (!(user instanceof SignedUserDTO)) {
                self.href = '/login';
            }
        });
    }

    setQueryParams() {
        const queryParamsString =  this.dataHref?(this.dataHref.split('?')[1]? this.dataHref.split('?')[1] : ''):'';
        let queryParams = {};
        if(queryParamsString) {
            queryParamsString.split('&').forEach(x => {
                const params = x.split('=');
                queryParams[params[0]] = params[1];
            });
        } else if(this.copyQueryParams) {
            queryParams = this.route.snapshot.queryParams;
        }
        this.query_params = queryParams;
    }

    setBaseLink() {
        this.href = this.dataHref? this.dataHref.split('?')[0].split('#')[0] : '';
    }

    setFragment() {
        this.fragment = this.dataHref? decodeURI(this.dataHref).split('?')[0].split('#')[1] : '';
        this.fragment = this.fragment? this.fragment : null;
    }

    scroll() {
        let section = document.getElementById(this.fragment) || document.getElementById(this.sectionAnchor);
        if (section) {
            if(!this.interactivityChecker.isFocusable(section)){
                section.setAttribute('tabindex', '-1');
            }
            section.focus();
        }
        /* else {
             window.location.href = '/#'+ this.sectionAnchor;
         }*/
    }

    navigateRelatively() {
        this.routeService.activatedRoute$.subscribe( route =>{
            this.router.navigate([this.href], {relativeTo: route, fragment: this.fragment, queryParams: this.query_params}).then();
        }).unsubscribe();
    }
}
